import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {FeatureTypeService} from '@catcore/services';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {EntitySchemaType} from '@catcore/utils/json-schema/entity-schema-to-json-schema';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {AvodCatalogBase} from '@catmodels/avod-catalog/avod-catalog-base/avod-catalog-base';
import {FeatureAvodCatalogService} from '@catmodels/avod-catalog/services/feature-avod-catalog.service';
import {ModalService} from '@catmodules/widgets/slide-in-modal/services/modal.service';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'cat-feature-avod-catalog',
  templateUrl: './feature-avod-catalog.component.html',
  styleUrls: ['./feature-avod-catalog.component.scss'],
})
export class FeatureAvodCatalogComponent extends AvodCatalogBase implements OnInit, OnDestroy {

  private currentResourceService;
  private featureSubscription;
  private feature;
  private featureSchema;

  get formIsReady() {
    let isReady = !isNullOrUndefined(this.form);
    isReady = isReady && !isNullOrUndefined(this.featureSchema);
    isReady = isReady && !isNullOrUndefined(this.avodCatalogServiceOptions);
    isReady = isReady && !isNullOrUndefined(this.modeOptions);
    isReady = isReady && !isNullOrUndefined(this.throttleOptions);
    return isReady;
  }

  constructor(private featureService: FeatureTypeService,
              formBuilder: FormBuilder,
              genericService: GenericResourceService,
              modalService: ModalService,
              private router: Router,
              private schemaService: EntitySchemaService,
              private avodCatalogService: FeatureAvodCatalogService) {
    super(formBuilder, genericService, modalService);

    this.service = this.avodCatalogService;
    this.isFeature = true;
    this.featureSchema = schemaService.getForEntityName(EntitySchemaType['FeatureAvodCatalogs']);
  }

  ngOnInit() {
    this.featureSubscription = this
      .featureService
      .getCurrent()
      .subscribe((feature: any) => {
        if (!isNullOrUndefined(feature)) {
          this.feature = feature;
        }
      });
  }

  ngOnDestroy() {
    if (this.featureSubscription) {
      this.featureSubscription.unsubscribe();
    }
  }

  onEntityReceived(entity) {
    this.currentResourceService = this.genericService.findServiceForResource(this.resourceUri);
  }

  // Down from this point all methods are protected

  protected beforeUpdateForm() {
    if (this.feature && this.feature.id) {
      this.featureService
        .getServices(this.feature.id.toString()).subscribe((services: any[]) => {
        this.updateAvodCatalogServiceOptions(services);
      });
    }

    if (this.featureSchema) {
      this.modeOptions = this.updateChoicesOptions(this.featureSchema.properties.mode.choices);
      this.throttleOptions = this.updateChoicesOptions(this.featureSchema.properties.throttle.choices);
    }
  }

  protected afterDelete() {
    this.featureService.refreshCurrent();
    this.router.navigate(['features', this.feature.id, 'properties']);
  }

  protected refresh() {
    this.currentAvodCatalogHandler.refresh();
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/avod-catalog/components/feature-avod-catalog/feature-avod-catalog.component.ts